import React, {useEffect, useState} from "react";
import axios from "axios";
import $ from "jquery";
import {Link} from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {useHistory} from 'react-router';
import {toAbsoluteUrl} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import alertify from "alertifyjs";

import {API_URL} from '../constants.js';

import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {useTranslation} from "react-i18next";

export function MachineList(props) {
    const {t} = useTranslation();
    const [machines, setMachines] = useState([]);
    const [machineId, setMachineId] = useState(-1);
    const [show, setShow] = useState(false);
    const history = useHistory();
    const [disabled, setDisabled] = useState(0);
    const [iconDisabled, setIconDisabled] = useState(1);

    const setCurrentMachine = (id) => {
        setMachineId(id);
        setShow(true);
    };

    const handleClose = () => setShow(false);

    const deleteMachine = () => {
        setDisabled(1);
        setIconDisabled(0);
        axios.post(API_URL + 'machine/' + machineId + '/delete').then((response) => {
            if (response.data.status) {
                history.go(0);
                setShow(false);
                alertify.success(response.data.message);
            } else {
                setDisabled(0);
                setIconDisabled(1);
                alertify.error(response.data.message);
                return null;
            }
        }).catch((error) => {
            setDisabled(0);
            setIconDisabled(1);
            alertify.error("Something went wrong. Try again!");
        });
    };

    useEffect(() => {
        axios.get(API_URL + 'machine').then((response) => {
            if (response.data.status) {
                setMachines(response.data.data);
            } else {
                alertify.error(response.data.message);
            }
        }).catch((error) => {
            alertify.error("Something went wrong. Try again!");
        });
    }, []);

    useEffect(() => {
        if (machines.length) {
            if ($.fn.DataTable.isDataTable("#machine_table")) {
                $("#machine_table").DataTable().destroy();
            }
            $("#machine_table").DataTable({
                paging: true,
                searching: true,
                ordering: true,
                info: true,
                autoWidth: false,
            });
        }
    }, [machines]);

    return (
        <>
            <Row>
                <Col md={12}>
                    <Card>
                        <CardHeader title={t("Machine List")}>
                            <CardHeaderToolbar>
                                <Link to="/machine/create" className="btn btn-primary btn-sm mx-3">
                                    {t("Create Machine")}
                                </Link>
                            </CardHeaderToolbar>
                        </CardHeader>
                        <CardBody style={{overflow: 'auto'}}>
                            <table id="machine_table" className="stratprop_datatable table table-bordered table-striped">
                                <thead>
                                <tr>
                                    <th>{t("SN.")}</th>
                                    <th>{t("Name")}</th>
                                    <th>{t("Short Code")}</th>
                                    <th>{t("Model")}</th>
                                    <th>{t("Actions")}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {machines.length > 0 ? (
                                    machines.map((machine, index) => (
                                        <tr key={`machine-` + machine.id}>
                                            <td>{index + 1}</td>
                                            <td>{machine.name}</td>
                                            <td>{machine.short_code || '-'}</td>
                                            <td>{machine.model || '-'}</td>
                                            <td>
                                                <Link to={`/machine/edit/${machine.id}`}
                                                      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
                                                      title={t("Edit")}>
                                                    <span className="svg-icon svg-icon-md svg-icon-primary">
                                                        <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}/>
                                                    </span>
                                                </Link>
                                                <a
                                                    onClick={() => setCurrentMachine(machine.id)}
                                                    className="btn btn-icon btn-light btn-hover-danger btn-sm mx-1"
                                                    title={t("Delete")}>
                                                    <span className="svg-icon svg-icon-md svg-icon-danger">
                                                        <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}/>
                                                    </span>
                                                </a>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={5}>{t("No Machines Found")}</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Delete Machine")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t("Are you sure you want to delete this machine?")}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>{t("Close")}</Button>
                    <Button variant="danger" onClick={deleteMachine} disabled={disabled}>
                        {t("Delete")}
                        <span dangerouslySetInnerHTML={{__html: disabled ? `<i class='fas fa-spinner fa-spin'></i>` : ``}}/>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
